//
import { RFormFields } from '@/components/reusable_components/next'

//
export default RFormFields
  .from([
    {
      type: 'date-field',
      name: 'new_accounting_date',
      flex: {
        xs12: true,
      },
      props: {
        label: 'Fecha contable'
      },
    },
  ])